import { Mark, mergeAttributes } from '@tiptap/core'

export const COMMENT_ANCHOR_MARK_NAME = 'commentAnchor'

export type CommentAnchorAttrs = {
  anchorId: string | null
}

export const CommentAnchorMark = Mark.create({
  name: COMMENT_ANCHOR_MARK_NAME,

  inclusive: false,

  excludes: '',

  addAttributes() {
    return {
      anchorId: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-comment-anchor-id'),
        renderHTML: (attrs: Record<string, unknown>) => (attrs['anchorId'] === null ? {} : { 'data-comment-anchor-id': String(attrs['anchorId']) }),
      },
    }
  },

  parseHTML() {
    return [{ tag: 'span[data-comment-anchor-id]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes, { class: 'comment-anchor' }), 0]
  },
})
